import { Fragment } from 'react';

import { currencyFormat } from 'common/helpers/numberHelper';
import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';

const Payment = (props) => {
  const { cart, currentStep, onEdit, settings } = props;
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('payment');
  };
  if (currentStep === 'complete') {
    return (
      <div>
        <div>
          <div>Payment info</div>
          <div>{renderTenders(cart.tenders, settings)}</div>
        </div>
        <a href="#" aria-label="Edit payment info" onClick={handleEdit}>
          Edit
        </a>
      </div>
    );
  }
  return null;
};

const renderTenders = (tenders, settings) => {
  if (tenders.length > 1) {
    return tenders.map((tender) => {
      if (tender.amountTendered === 0 || tender.chargeStatus === 'Failed') {
        return null;
      }
      if (tender.tenderType === 'Credit Card') {
        return (
          <Fragment key={tender.id}>
            <CreditCardDisplay creditCard={tender.creditCard} />
            <br />
            Amount: {currencyFormat(tender.amountTendered, settings)} <br />
            <br />
          </Fragment>
        );
      }
      if (tender.tenderType === 'Gift Card') {
        return (
          <Fragment key={tender.id}>
            Gift Card: {tender.giftCard.maskedCode}
            <br />
            Amount: {currencyFormat(tender.amountTendered, settings)}
            <br />
          </Fragment>
        );
      }
      return <Fragment key={tender.id}>{tender.tenderType}</Fragment>;
    });
  }
  return tenders.map((tender) => {
    if (tender.amountTendered === 0) {
      return null;
    }
    if (tender.tenderType === 'Credit Card') {
      return (
        <Fragment key={tender.id}>
          <CreditCardDisplay creditCard={tender.creditCard} />
        </Fragment>
      );
    }
    if (tender.tenderType === 'Gift Card') {
      return (
        <Fragment key={tender.id}>
          Gift Card: {tender.giftCard.code}
          <br />
          Amount Tendered: {currencyFormat(tender.amountTendered, settings)}
          <br />
        </Fragment>
      );
    }
    return <Fragment key={tender.id}>{tender.tenderType}</Fragment>;
  });
};

export default Payment;
